export default __webpack_public_path__ + "static/media/location-icon.a48509e3.svg";